class MemberView {
    id: number;
    status: number;
    blockReason: number | null;
    companyName: string;
    userGroupId: number;
    accountManagerName: string | null;
    vendorName: string | null;
    holidayStart: Date | null;
    holidayEnd: Date | null;

    constructor(data?: any) {
        this.id = data?.id;
        this.status = data?.status;
        this.blockReason = data?.blockReason ?? null;
        this.companyName = data?.companyName;
        this.userGroupId = data?.userGroupId;
        this.accountManagerName = data?.accountManagerName ?? null;
        this.vendorName = data?.vendorName ?? null;
        this.holidayStart = data?.holidayStart ? new Date(data.holidayStart) : null;
        this.holidayEnd = data?.holidayEnd ? new Date(data.holidayEnd) : null;
    }
}

export class NotificationListView {
    id: number;
    typeNotif: number;
    extraInfo: string | null;
    dateNotif: Date | null;
    // Holiday window snapshotted on the notification (type 5/6). Preferred over member.holidayStart
    // (expertrole), which is null for expertbustype-scoped vacations. Null on pre-existing rows.
    holidayStart: Date | null;
    holidayEnd: Date | null;
    // Null = expert-role scope (whole supplier); a value = the single expertbustype on holiday.
    holidayExpertBustypeId: number | null;
    member: MemberView;

    constructor(data: any) {
        this.id = data.id;
        this.typeNotif = data.typeNotif;
        this.extraInfo = data.extraInfo ?? null;
        this.dateNotif = data.dateNotif ? new Date(data.dateNotif) : null;
        this.holidayStart = data?.holidayStart ? new Date(data.holidayStart) : null;
        this.holidayEnd = data?.holidayEnd ? new Date(data.holidayEnd) : null;
        this.holidayExpertBustypeId = data?.holidayExpertBustypeId ?? null;
        this.member = new MemberView(data?.member);
    }
}
